import BooleanWithLabel from "@/Components/Boolean/BooleanWithLabel";
import { SettingsField } from "@/Components/WebsiteSettings/SettingsCard";
import useCountryConfigHook from "@/shared/hooks/useCountryConfigHook";
import { cn } from "@/shared/utils/cn";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const Is18PlusWebsite = () => {
  const { t } = useTranslation("", { keyPrefix: "settings_page" });
  const { control } = useFormContext();
  const { isTurkiye } = useCountryConfigHook();

  return (
    <SettingsField
      label={t("cards.ageRestriction")}
      className={cn(isTurkiye && "hidden")}
    >
      <Controller
        name="is18PlusWebsite"
        control={control}
        render={({ value, onChange }) => (
          <BooleanWithLabel checked={value} onChange={() => onChange(!value)}>
            {t("is18PlusWebsite")}
          </BooleanWithLabel>
        )}
      />
    </SettingsField>
  );
};

export default Is18PlusWebsite;
